import EcoImg from 'eco-design/base/eco-img';
import { AnimatedGrid } from '../../../us/StatusA/Components/AnimatedSection';
import css from './index.module.scss';

interface ImgSectionProps {
    label?: string;
    title: string;
    desc?: string;
    pc: string;
    h5?: string;
    sectionId: string;
}
const ImgSection: React.FC<ImgSectionProps> = ({ sectionId, label, title, desc, pc, h5 }) => {
    return (
        <section
            className={`imgSection ${css.section} ${sectionId} GtmModuleData-section`}
            id={sectionId}
            data-section-id={sectionId}
            data-section-title={typeof title === 'string' ? title : ''}
        >
            <div className="eco-img">
                <EcoImg pc={pc} pad={pc} h5={h5 || pc} className="comp-bg" isOpenLazy={true} />
            </div>
            <div className={`info enter`}>
                <AnimatedGrid variant="fadeInUp" options={{ stagger: 0.2, delay: 100, threshold: 0.2 }}>
                    {label && <p className="lable">{label}</p>}
                    <p className="title">{title}</p>
                    {desc && <p className="desc">{desc}</p>}
                </AnimatedGrid>
            </div>
        </section>
    );
};

export default ImgSection;
